import React from 'react';
import {
  Container,
  Typography,
  Paper,
  Box
} from '@mui/material';
import FeedbackPanel from './FeedbackPanel';

const AdminFeedback = () => {
  return (
    <Container maxWidth="xl">
      <Paper elevation={0} sx={{ mb: 3, p: 3, bgcolor: 'background.default' }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Feedback Management
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Review and manage user feedback, bug reports, and feature suggestions.
        </Typography>
      </Paper>

      <Box>
        <FeedbackPanel />
      </Box>
    </Container>
  );
};

export default AdminFeedback; 